import { ConceptFlowSvgPacket } from "@/app/types/home/ConceptFlow";
import {
  FLOW_PACKET_DURATION,
  FLOW_PACKET_FADE_TIMES,
  FLOW_PACKET_FADE_VALUES,
  FLOW_PACKET_KEY_POINTS,
  FLOW_PACKET_KEY_SPLINES,
  FLOW_PACKET_KEY_TIMES,
  FLOW_PACKET_SHAPE,
} from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";

type Props = {
  packet: ConceptFlowSvgPacket;
};

export default function ConceptFlowPacket(props: Props) {
  const { packet } = props;

  return (
    <path className={styles.packetDot} d={FLOW_PACKET_SHAPE} opacity={0}>
      <animateMotion
        path={packet.d}
        begin={packet.begin}
        dur={FLOW_PACKET_DURATION}
        repeatCount="indefinite"
        calcMode="spline"
        keyPoints={FLOW_PACKET_KEY_POINTS}
        keyTimes={FLOW_PACKET_KEY_TIMES}
        keySplines={FLOW_PACKET_KEY_SPLINES}
      />
      <animate
        attributeName="opacity"
        begin={packet.begin}
        dur={FLOW_PACKET_DURATION}
        repeatCount="indefinite"
        values={FLOW_PACKET_FADE_VALUES}
        keyTimes={FLOW_PACKET_FADE_TIMES}
      />
    </path>
  );
}
